import styles from './VServicesModalReturnDetails.module.css'

// Modal
import { useModalWindow } from "react-modal-global";
import useScrollBlock from "../../../../../../customHooks/useScrollBlock";
import PopupAppearLayout from "../../../../common/Modals/Layouts/PopupAppearLayout";
// 
import image1 from './image1.jpg'
import image2 from './image2.jpg'
import image3 from './image3.jpg'

const VServicesModalReturnDetails = () => {

    const modal = useModalWindow();
    const [blockScroll, allowScroll] = useScrollBlock();
    const closeModal = () => {
      // setTimeout(function(){allowScroll()}, 150);
      allowScroll()
      modal.close()
    } 
    
    return (
        <PopupAppearLayout classNameLayout={styles.popup__layout}>
            <div className={styles.container}>

                
                {/* HEADER */}
                <div className={styles.header_container}>
                    <div className={styles.header_title}>
                        <p>Возврат тары</p>
                    </div>
                    
                    <button
                        className={styles.popup_layout__close}
                        type="button"
                        onClick={closeModal}
                        aria-label="Закрыть"
                    >
                        &#9587;
                    </button>
                </div>
                
                {/* CONTENT */}
                <div className={styles.content__container}>
                    {/* row */}
                    <div className={styles.row}>
                        <div className={styles.title}>
                            КАКИЕ БУТЫЛИ (19л) ПРИНИМАЕМ НА ОБМЕН:
                        </div>
                        <div className={styles.text}>
                            На дне бутылей есть обозначения, указывающие, какая компания произвела бутыль, в каком году и из какого пластика. ОТ ДРУГИХ ПОСТАВЩИКОВ ПРИНИМАЕМ ТАРУ ТОЛЬКО ОТ ПРОИЗВОДИТЕЛЯ AQUA WELL (см.фото) и в состоянии, пригодном для повторного использования, — без мусора, без физических повреждений и деформации, без трещин, проколов, порезов, вмятин, следов потертостей, без помутнения или изменения цвета, без следов химического воздействия, без пятен краски, технического масла и т.д. Также, без признаков застоя воды, бактериального и грибкового роста, без образования зеленого налета на стенках бутыли, без слизи бурого и черного цвета, без плесени, без запаха, и без гравировки ЛОГО других производителей на пластике боковой стенки бутыли
                        </div>
                    </div>
                    
                    <div className={styles.imageBlock}>
                        <img className={styles.image} src={image1} alt="Санитарная обработка аппаратов" />
                        <img className={styles.image} src={image2} alt="Санитарная обработка аппаратов" />
                        <img className={styles.image} src={image3} alt="Санитарная обработка аппаратов" />
                    </div>

                    {/* buttons */}
                    <div className={styles.btnBlock}>
                        <button
                            className={styles.btn_return}
                            type="button"
                            onClick={closeModal}
                        >
                            Закрыть
                        </button>
                    </div>
                </div>

            </div>
        </PopupAppearLayout>
    );   
}

export default VServicesModalReturnDetails;